<template>
	<div class="layout">
		<applyBox
		:applyLogin="applyLogin"
		@closeWin="closeWin"></applyBox>
		<!-- logo -->
		<div class="top_bar">
			<div class="top_bar_wrap">
				<div class="logo">
					<img src="../../assets/home/logo.png" >
				</div>
				<div class="registerwrap">
					<span class="login_btn" @click="login">登录</span>
					<span class="register" @click="applyShow">申请入驻</span>
				</div>
			</div>
		</div>
		<!-- 导航 -->
		<div class="nav">
			<div class="nav_wrap">
				<router-link :to="{path:'/?index=1'}" class="nav_item"  :class="{selectNav:selectNav == 1}">首页</router-link>
				<router-link :to="{path:'/news?index=2'}" class="nav_item"  :class="{selectNav:selectNav == 2}">新闻公告</router-link>
				<router-link :to="{path:'/yxfc?index=3'}" class="nav_item"  :class="{selectNav:selectNav == 3}">院校风采</router-link>
				<router-link :to="{path:'/kcsz?index=4'}" class="nav_item"  :class="{selectNav:selectNav == 4}">课程思政</router-link>
				<router-link :to="{path:'/szjk?index=5'}" class="nav_item"  :class="{selectNav:selectNav == 5}">思政金课</router-link>
				<router-link :to="{path:'/szzy?index=6'}" class="nav_item"  :class="{selectNav:selectNav == 6}">思政资源</router-link>
			</div>
		</div>
		<!-- 显示区域 -->
		<div class="showCenter">
			<router-view @highLight="changeNav" @applyShow="applyShow"></router-view>
		</div>
		<div class="footer">
			<div class="footer_wrap">
				<div>
					<p>— 陕西高校网络思想政治工作中心主办 —</p>
					<p>地址：陕西省西安市未央区陕西科技大学四号教学楼</p>
					<p>技术支持：人民视讯文化有限公司&nbsp;&nbsp;&nbsp;
					技术服务：400-901-9665</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import applyBox from '@/components/apply.vue';
	export default {
		data(){
			return{
				selectNav:1,
				applyLogin:false
			}
		},
		components: {
			applyBox
		},
		methods:{
			// 接收子元素传来高亮导航 并跳转详情页
			changeNav(index,bsid,id,type){
				document.getElementsByClassName("layout").scrollTop = 0;
				var that = this;
				that.selectNav = index;
				if(bsid != "" && id != ""){
					that.$szzy.goDetail(bsid,id,index,type)
				}
			},
			// 申请入驻窗口打开
			applyShow(){
				var that = this;
				that.applyLogin = true;
			},
			// 申请入驻窗口关闭
			closeWin(){
				var that = this;
				that.applyLogin = false;
			},
			// 学校列表入口
			login(){
				var that = this;
				that.$router.push('/gxyxList')
			}
		},
		mounted () {
			
		}
	}
</script>

<style lang="scss">
	@import '@/common/index.scss';
	.layout{
		width: 100%;
		height: 100%;
		.top_bar{
			height: 86px;
			width: 100%;
			background: #fff;
			&_wrap{
				width: $indexWidth;
				height: 100%;
				margin: auto;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.logo{
					height: 46px;
					img{
						height: 100%;
						width: auto;
					}
				}
				.registerwrap{
					display: flex;
					align-items: center;
					.login_btn{
						cursor: pointer;
						display: inline-block;
						color: #fff;
						background:#CB272B;
						width: 80px;
						height: 36px;
						border-radius: 20px;
						font-size: 14px;
						text-align: center;
						line-height: 36px;
						margin-right: 10px;
					}
					.register{
						cursor: pointer;
						display: inline-block;
						width: 90px;
						height: 36px;
						border-radius: 20px;
						border: 1px solid #CB272B;
						color: #CB272B;
						font-size: 14px;
						text-align: center;
						line-height: 36px;
						span{
							cursor: pointer;
						}
						span:hover{
							opacity: 0.8;
						}
					}
				}
			}
		}
		// 导航
		.nav{
			width: 100%;
			height: 48px;
			line-height: 48px;
			background: #CB272B;
			&_wrap{
				margin: auto;
				display: flex;
				align-items: center;
				justify-content: space-between;
				height: 100%;
				font-size: $indexSize;
				width: $indexWidth;
				.nav_item{
					display: block;
					cursor: pointer;
					padding: 0 40px;
					text-align: center;
					color: #fff;
					text-decoration: none;
					&:hover{
						background-color: #AC1418;
					}
				}
				.nav_item:hover{
					font-family: 'syht';
				}
			}
		}
		.footer{
			width: 100%;
			height: 160px;
			color: #fff;
			margin-top: $globalBottom;
			background: #CB272B;
			&_wrap{
				width: $indexWidth;
				margin: auto;
				display: flex;
				height: 100%;
				align-items: center;
				justify-content: center;
				div>p{
					font-size: $indexSize;
					line-height: 30px;
					text-align: center;
				}
				div>p:nth-child(1){
					font-weight: bold;
				}
			}
		}
		.showCenter{
			width: 100%;
			font-size: 0;
			margin: auto;
			min-height: 400px;
		}
	}
	.selectNav{
		background-color: #AC1418 !important;
		font-family: 'syht' !important;
		font-weight: bold;
	}
</style>
